import { useId } from 'react'
import { CLUB_AWARDS, formatClubAwardTotal, type ShowResultsReleasePayloadOutput } from '@schemas'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

const names = new Intl.ListFormat('en', { type: 'conjunction' })

/** Released club awards, on the public results page and in the release review. */
export function ClubAwards({ results }: { results: ShowResultsReleasePayloadOutput }) {
  const headingId = useId()
  if (!('clubAwards' in results)) return null
  const given = CLUB_AWARDS.flatMap(item => {
    const award = results.clubAwards[item.key]
    return award ? [{ ...item, award }] : []
  })
  if (given.length === 0) return null
  return (
    <section aria-labelledby={headingId} className="space-y-4">
      <h2 id={headingId} className="text-xl font-semibold">
        Club awards
      </h2>
      <div className="grid gap-4 grid-cols-[repeat(auto-fit,minmax(13rem,1fr))]">
        {given.map(({ title, basis, measure, award }) => (
          <Card key={title} className="min-w-0">
            <CardHeader>
              <CardDescription>
                {title} · {basis}
              </CardDescription>
              {/* Clubs on equal totals share the award. */}
              <CardTitle className="text-xl">
                {names.format(award.winners.map(club => club.clubName))}
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-1 text-sm">
              <p>{formatClubAwardTotal(award.winners[0], measure)}</p>
              {award.runnersUp.length > 0 && (
                <p className="text-muted-foreground">
                  Runner-up: {names.format(award.runnersUp.map(club => club.clubName))} (
                  {formatClubAwardTotal(award.runnersUp[0], measure)})
                </p>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  )
}
